// extracted by mini-css-extract-plugin
export default {"root":"Header__root--EiAKN","overlay":"Header__overlay--WKDbO","address":"Header__address--wms7v","vendors":"Header__vendors--GllbB"};